export class InvalidPinError extends Error {
  constructor(message = 'Invalid or expired PIN') {
    super(message);
    this.name = 'InvalidPinError';
  }
}

